<template>
  <v-carousel
    height="100%"
    hide-delimiter-background
    :show-arrows="this.$vuetify.breakpoint.mdAndUp"
    @change="setBackground"
  >
    <v-img
      :src="require('@/assets/geoffrey.png')"
      contain
      eager
      aspect-ratio="1"
      class="geoffrey-tutorial"
      :style="{ 'right': getGeoffreyPosition() + 'vw'}"
    />
    <v-carousel-item
      v-for="(slide, i) in slides"
      :key="i"
    >
      <v-sheet
        :color="colors[i]"
        height="100%"
      >
        <v-row
          class="fill-height"
          justify="center"
        >
          <div class="slide-container">
            <div class="my-12 display-3 font-weight-bold">
              {{ $vuetify.lang.t('$vuetify.tutorial.slide'+i+'.title') }}
            </div>
            <div class="title">
              {{ $vuetify.lang.t('$vuetify.tutorial.slide'+i+'.text') }}
            </div>
          </div>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <div class="text-center register-button-area">
      <v-btn
        outlined
        color="white"
        x-large
        class="px-5"
        @click="register"
      >
        <v-icon
          left
          dark
        >
          mdi-linkedin
        </v-icon>
        {{ $vuetify.lang.t('$vuetify.signInLinkedIn').toUpperCase() }}
      </v-btn>
    </div>
  </v-carousel>
</template>

<script>
import { AuthSocialMixin as vueAuth, AuthSocialMixin } from '@/modules/core/services/auth/auth_user.service'
import Vue from 'vue'
import {store} from "@/modules/store/store-module";

export default Vue.extend({
  components: {
  },
  data: () => ({
    positioning: screen.width <= 1080 ? { base: -65, increment: 5 } : { base: -15, increment: 2 },
    page: 0,
    geoffreyWidth: 500,
    geoffreyPosition: -50,
    windowWidth: 1000,
    colors: ['#c34992', '#ff9600', '#97c349', '#00aff0'],
    slides: [0, 1, 2, 3]
  }),
  computed: {
  },
  methods: {
    setBackground (page) {
      this.page = page
    },
    getGeoffreyPosition () {
      return this.positioning.base + (this.positioning.increment * this.page)
    },
    register () {
      let token = ''

      let _this = this

      this.$auth.authenticate('linkedin').then(function (response) {
        _this.$store.dispatch('auth/convert_social_token', response)
      }).catch(function (error) {
        console.log(error)
        _this.$store.dispatch('snackbar/activate',
          { message: 'Algo ha fallado y no hemos podido autentificarte, prueba mas tarde', code: 1 })
        console.debug("not log in")
      })
    }
  }
})
</script>

<style>

.slide-container {
  margin-left: 10%;
  margin-right: 10%;
}

.geoffrey-tutorial {
  position: absolute;
  bottom: 20%;
  width: calc(80 * 1vh);
  z-index: 1;
  transform: rotate(-40deg);
  opacity: 0.4;
}
.v-carousel__controls {
  position: absolute;
  margin-bottom: calc(2% + 2vh);
}
.register-button-area {
  position: absolute;
  width: 100%;
  z-index: 1000;
  bottom: 50px;
  margin-bottom: 8rem;
}

</style>
